export function getLocaleByCurrency(currency: string): string {
    const currencyLocaleMap: { [key: string]: string } = {
        'ARS': 'es-AR', // Peso argentino - Argentina
        'AUD': 'en-AU', // Dólar australiano - Australia
        'BGN': 'bg-BG', // Lev búlgaro - Bulgaria
        'BOB': 'es-BO', // Boliviano - Bolivia
        'BRL': 'pt-BR', // Real brasileño - Brasil
        'BYN': 'be-BY', // Rublo bielorruso - Bielorrusia
        'CAD': 'en-CA', // Dólar canadiense - Canadá
        'CDF': 'fr-CD', // Franco congoleño - República Democrática del Congo
        'CHF': 'de-CH', // Franco suizo - Suiza (También fr-FR, it-IT dependiendo de la región)
        'CLP': 'es-CL', // Peso chileno - Chile
        'CNY': 'zh-CN', // Yuan chino - China
        'COP': 'es-CO', // Peso colombiano - Colombia
        'CRC': 'es-CR', // Colón costarricense - Costa Rica
        'CZK': 'cs-CZ', // Corona checa - República Checa
        'DKK': 'da-DK', // Corona danesa - Dinamarca
        'DOP': 'es-DO', // Peso dominicano - República Dominicana
        'EUR': 'de-DE', // Euro - Alemania (utilizado en muchos países europeos, cada uno con su propio locale)
        'GBP': 'en-GB', // Libra esterlina - Reino Unido
        'GEL': 'ka-GE', // Lari georgiano - Georgia
        'GHS': 'en-GH', // Cedi ghanés - Ghana
        'GNF': 'fr-GN', // Franco guineano - Guinea
        'GTQ': 'es-GT', // Quetzal guatemalteco - Guatemala
        'HKD': 'zh-HK', // Dólar de Hong Kong - Hong Kong
        'HUF': 'hu-HU', // Florín húngaro - Hungría
        'IDR': 'id-ID', // Rupia indonesia - Indonesia
        'INR': 'hi-IN', // Rupia india - India
        'ISK': 'is-IS', // Corona islandesa - Islandia
        'JPY': 'ja-JP', // Yen japonés - Japón
        'KES': 'sw-KE', // Chelín keniano - Kenia
        'MWK': 'en-MW', // Kwacha malauí - Malaui
        'MXN': 'es-MX', // Peso mexicano - México
        'MZN': 'pt-MZ', // Metical mozambiqueño - Mozambique
        'NGN': 'en-NG', // Naira nigeriana - Nigeria
        'NOK': 'nb-NO', // Corona noruega - Noruega
        'NZD': 'en-NZ', // Dólar neozelandés - Nueva Zelanda
        'PEN': 'es-PE', // Sol peruano - Perú
        'PHP': 'fil-PH', // Peso filipino - Filipinas
        'PLN': 'pl-PL', // Zloty polaco - Polonia
        'PYG': 'es-PY', // Guaraní paraguayo - Paraguay
        'RSD': 'sr-RS', // Dinar serbio - Serbia
        'RUB': 'ru-RU', // Rublo ruso - Rusia
        'SEK': 'sv-SE', // Corona sueca - Suecia
        'SLL': 'en-SL', // Leone sierraleonés - Sierra Leona
        'SYP': 'ar-SY', // Libra siria - Siria
        'TND': 'ar-TN', // Dinar tunecino - Túnez
        'TRY': 'tr-TR', // Lira turca - Turquía
        'TZS': 'sw-TZ', // Chelín tanzano - Tanzania
        'UAH': 'uk-UA', // Grivna ucraniana - Ucrania
        'UGX': 'en-UG', // Chelín ugandés - Uganda
        'USD': 'en-US', // Dólar estadounidense - Estados Unidos
        'UYU': 'es-UY', // Peso uruguayo - Uruguay
        'VND': 'vi-VN', // Dong vietnamita - Vietnam
        'XAF': 'fr-CM', // Franco CFA BEAC - Camerún (utilizado en varios países de África Central)
        'XOF': 'fr-CI', // Franco CFA BCEAO - Costa de Marfil (utilizado en varios países de África Occidental)
        'ZAR': 'en-ZA', // Rand sudafricano - Sudáfrica
    };
  
    return currencyLocaleMap[currency] || 'en-EN';
  }